import gql from 'graphql-tag';

export const getEnrollmentCourses = gql`
  query getEnrollmentCourses(
    $period: String!
    $prog: String!
    $plan: String!
    $career: String!
    $campus: String!
  ) {
    coursesSchedules {
      getCourses(
        period: $period
        prog: $prog
        plan: $plan
        career: $career
        campus: $campus
      ) {
        id
        code
        name
        hours
        credits
        type
        cicle
      }
    }
  }
`;
